import { Box, Collapse, IconButton, styled, Typography } from '@mui/material';
import { Minus, Plus, RefreshCwIcon } from 'lucide-react';
import { useState } from 'react';
import { Changelog } from '../../types/Changelog/Changelog.type';
import { formatReleaseDate } from '../../utils/formatReleaseDate';
import ChangelogItemComponent from './ChangelogItemComponent.tsx';

const TimeLineBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 160,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  paddingRight: 12.5,
  paddingTop: 24,
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 58,
    bottom: -14,
    right: 24,
    width: 2,
    backgroundColor: theme.palette.accentBlue.main,
  },
}));

const ChangelogEntryComponent = ({ changelogEntry }: { changelogEntry: Changelog }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ display: 'flex', gap: '48px' }}>
      <TimeLineBox>
        <Typography sx={{ color: 'accentBlue.main', fontWeight: 700, fontSize: '14px' }}>
          {formatReleaseDate(changelogEntry.release_date)}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 26,
            height: 26,
            borderRadius: '50%',
            backgroundColor: 'accentBlue.main',
            color: '#fff',
          }}
        >
          <RefreshCwIcon size={14} />
        </Box>
      </TimeLineBox>

      <Box sx={{ flex: 1, backgroundColor: '#F9FBFF', padding: 4, marginBottom: 5 }}>
        <Box
          onClick={() => setExpanded((prev) => !prev)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            cursor: 'pointer',
          }}
        >
          <Typography variant='h5' sx={{ color: 'accentBlue.main', fontSize: '20px', fontWeight: 700 }}>
            {changelogEntry.title}
          </Typography>
          <IconButton size='small' sx={{ color: 'primary.main' }}>
            {expanded ? <Minus size={20} /> : <Plus size={20} />}
          </IconButton>
        </Box>

        <Typography sx={{ marginTop: 2, color: 'text.primary' }}>{changelogEntry.summary}</Typography>

        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <Box sx={{ marginTop: 4, display: 'flex', flexDirection: 'column', gap: 3 }}>
            {changelogEntry.items.map((feature, index) => (
              <ChangelogItemComponent key={`${feature.title}-${index}`} changelogItem={feature} />
            ))}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default ChangelogEntryComponent;
